<template>
  <div class="zj-header">
    <div
      class="zj-app-logo"
      v-if="THM('header.logo.visiable', true)"
      :style="THM('header.logo.style', { 'background-image':THM('header.logo.img', CNF('app.logo'))})" >
      <h1
        class="zj-app-title"
        v-if="THM('header.title.visiable', true)"
        :style="THM('header.title.style', {})">{{THM('header.title.text', CNF('app.name'))}}</h1>
    </div> 
   
    <zj-nav-menu :height="height" />
    <zj-action-panel :height="height" />
    <div class="zj-header-bg">
      <div class="zj-header-logo"></div>
      <div class="zj-header-bg-p1"></div>
      <div class="zj-header-bg-p2"></div>
      <div class="zj-header-bg-p3"></div>
      <div class="zj-header-bg-p4"></div>
      <div class="zj-header-circle xuanzhun"></div>
      <div class="zj-header-bline-top"></div>
      <div class="zj-header-bline-bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZjHeader',
  props: {
    height: String
  },
  computed: {
    style() {
      return {
        height: this.height
      }
    }
  }
}
</script>
